import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 justify-between items-center gap-4 py-2 px-4 pt-1 w-full max-w-full flex-grow-0" }
const _hoisted_2 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_3 = { class: "flex-grow px-[13px] h-10 flex flex-row items-center mt-5 justify-start gap-2" }
const _hoisted_4 = { class: "flex-grow text-xs font-semibold align-middle" }
const _hoisted_5 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_6 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_7 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_8 = { class: "col-span-3 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_9 = { class: "col-span-1 flex flex-row max-w-1/6 h-full items-end justify-end align-center gap-1.5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Tem certeza de que deseja excluir esta configuração do provedor?", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
  /*#__PURE__*/_createTextVNode("Essa ação é "),
  /*#__PURE__*/_createElementVNode("strong", null, "irreversível"),
  /*#__PURE__*/_createTextVNode(" e não poderá ser desfeita. ")
], -1)

import { ref, watch } from 'vue';
import { Pencil, Trash2, CircleCheck, CircleX } from 'lucide-vue-next';
import { PropType } from 'vue';
import Label from '@/components/ui/label/Label.vue';
import ProviderIcon from '@/components/ProviderIcon.vue';
import { PartnerProvider } from '@/http/partnerProvider';
import Input from '@/components/ui/input/Input.vue';
import { PartnerProviderPatchRequest } from '@/http/partnerProvider';
import { DELETE_PARTNER_PROVIDERS, PATCH_PARTNER_PROVIDERS } from '@/store';
import { useStore } from 'vuex';
import Button from '@/components/ui/button/Button.vue';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerProviderCard',
  props: {
    partnerProvider: {
        type: Object as PropType<PartnerProvider>,
        required: false
    },
    displayToast: {
        type: Function,
        required: true
    }
},
  setup(__props) {

const store = useStore();
const isEditing = ref(false);
const openDelete = ref(false);

const props = __props;

const presentationNameInProvider = ref(props.partnerProvider?.presentationNameInProvider);
const webhookVerificationToken = ref(props.partnerProvider?.webhookVerificationToken);
const tokenInProvider = ref(props.partnerProvider?.tokenInProvider);
const idInProvider = ref(props.partnerProvider?.idInProvider);

const validateNotEmptyString = (value?: string): boolean => {
    return value !== undefined && value.trim() !== '';
};

const showPresentationNameInProviderInvalidMessage = ref<boolean>(false);
watch(presentationNameInProvider, (newValue) => {
    showPresentationNameInProviderInvalidMessage.value = !validateNotEmptyString(newValue);
});

const showWebhookVerificationTokenInvalidMessage = ref<boolean>(false);
watch(webhookVerificationToken, (newValue) => {
    showWebhookVerificationTokenInvalidMessage.value = !validateNotEmptyString(newValue);
});

const showTokenInProviderInvalidMessage = ref<boolean>(false);
watch(tokenInProvider, (newValue) => {
    showTokenInProviderInvalidMessage.value = !validateNotEmptyString(newValue);
});

const showIdInProviderInvalidMessage = ref<boolean>(false);
watch(idInProvider, (newValue) => {
    showIdInProviderInvalidMessage.value = !validateNotEmptyString(newValue);
});


const toggleEdit = () => {
    isEditing.value = !isEditing.value;
};


const isAnyFieldEmpty = () => {
    return (presentationNameInProvider.value === "" ||
        webhookVerificationToken.value === "" ||
        tokenInProvider.value === "" ||
        idInProvider.value === ""
    );
};


const getInvalidParametersMessages = () => {
    let errors = `${showPresentationNameInProviderInvalidMessage.value ? "Nome de Apresentação, \n" : ""}` +
        `${showTokenInProviderInvalidMessage.value ? "Token no Provedor, \n" : ""}` +
        `${showIdInProviderInvalidMessage.value ? "Identificação no Provedor, \n" : ""}` +
        `${showWebhookVerificationTokenInvalidMessage.value ? "Webhook Verification Token, \n" : ""}`;
    let messages = 'Você também precisa preencher os seguintes campos: ' + errors.slice(0, errors.length - 3) + '.';

    return messages;
};
const patchPartnerProvider = async () => {
    if (props.partnerProvider?.id === undefined) { return; }
    if (isAnyFieldEmpty()) {
        props.displayToast('Há dados inválidos!', 'destructive', getInvalidParametersMessages());
        return;
    }
    let payload: PartnerProviderPatchRequest = {
        partnerProviderId: props.partnerProvider.id,
        presentationNameInProvider: presentationNameInProvider.value,
        tokenInProvider: tokenInProvider.value,
        webhookVerificationToken: webhookVerificationToken.value,
    };

    await store.dispatch(PATCH_PARTNER_PROVIDERS, payload);
    toggleEdit();
    props.displayToast('As informações do provedor foram atualizadas com sucesso!', 'default');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Label, { class: "text-left h-1" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProviderIcon, {
          class: "flex-grow-0",
          provider: __props.partnerProvider?.partnerProviderType
        }, null, 8, ["provider"]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.partnerProvider?.partnerProviderType ===
                    'INSTAGRAM'
                    ?
                    'Instagram' : 'WhatsApp'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Label, {
        class: _normalizeClass(["text-left", { 'text-red-500': showPresentationNameInProviderInvalidMessage.value }])
      }, {
        default: _withCtx(() => [
          _createTextVNode("Nome de Apresentação")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({
                    'placeholder:text-gray-500': isEditing.value,
                    'bg-gray-200 border-gray-400': !isEditing.value,
                    'ring-red-500 border-red-500': showPresentationNameInProviderInvalidMessage.value
                }),
        readonly: !isEditing.value,
        defaultValue: __props.partnerProvider?.presentationNameInProvider,
        modelValue: presentationNameInProvider.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((presentationNameInProvider).value = $event))
      }, null, 8, ["class", "readonly", "defaultValue", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Label, {
        class: _normalizeClass(["text-left", { 'text-red-500': showIdInProviderInvalidMessage.value }])
      }, {
        default: _withCtx(() => [
          _createTextVNode("Identificação no Provedor")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({
                    'placeholder:text-gray-500': isEditing.value,
                    'bg-gray-200 border-gray-400': !isEditing.value,
                    'ring-red-500 border-red-500': showIdInProviderInvalidMessage.value
                }),
        readonly: !isEditing.value,
        defaultValue: __props.partnerProvider?.idInProvider,
        modelValue: idInProvider.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((idInProvider).value = $event))
      }, null, 8, ["class", "readonly", "defaultValue", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(Label, {
        class: _normalizeClass(["text-left", { 'text-red-500': showTokenInProviderInvalidMessage.value }])
      }, {
        default: _withCtx(() => [
          _createTextVNode("Token")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({
                    'placeholder:text-gray-500': isEditing.value,
                    'bg-gray-200 border-gray-400': !isEditing.value,
                    'ring-red-500 border-red-500': showTokenInProviderInvalidMessage.value
                }),
        readonly: !isEditing.value,
        defaultValue: __props.partnerProvider?.tokenInProvider,
        modelValue: tokenInProvider.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tokenInProvider).value = $event))
      }, null, 8, ["class", "readonly", "defaultValue", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(Label, {
        class: _normalizeClass(["text-left", { 'text-red-500': showWebhookVerificationTokenInvalidMessage.value }])
      }, {
        default: _withCtx(() => [
          _createTextVNode("Webhook Verification Token")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({
                    'placeholder:text-gray-500': isEditing.value,
                    'bg-gray-200 border-gray-400': !isEditing.value,
                    'ring-red-500 border-red-500': showWebhookVerificationTokenInvalidMessage.value
                }),
        readonly: !isEditing.value,
        defaultValue: __props.partnerProvider?.webhookVerificationToken,
        modelValue: webhookVerificationToken.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((webhookVerificationToken).value = $event))
      }, null, 8, ["class", "readonly", "defaultValue", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (!isEditing.value)
        ? (_openBlock(), _createBlock(_unref(Dialog), {
            key: 0,
            open: openDelete.value,
            "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((openDelete).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(Button, {
                    variant: "ghost",
                    size: "icon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Trash2), { class: "text-slate-400" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogContent), { class: "pt-4" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogHeader), { class: "flex flex-row justify-between items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Deletar provedor?")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(DialogClose), null, {
                        default: _withCtx(() => [
                          _createVNode(Button, {
                            variant: "ghost",
                            class: "px-1.5",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (openDelete.value = false))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CircleX), { class: "text-gray-600" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    _createTextVNode(" Nome de exibição: " + _toDisplayString(presentationNameInProvider.value) + " ", 1),
                    _hoisted_11
                  ]),
                  _createVNode(_unref(DialogFooter), null, {
                    default: _withCtx(() => [
                      _createVNode(Button, {
                        type: "submit",
                        onClick: _cache[5] || (_cache[5] = async () => {
                                await _unref(store).dispatch(_unref(DELETE_PARTNER_PROVIDERS), props.partnerProvider?.id);
                                openDelete.value = false;
                            }),
                        variant: "destructive"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Deletar ")
                        ]),
                        _: 1
                      }),
                      _createVNode(Button, {
                        variant: "ghost",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (openDelete.value = false)),
                        class: "px-1.5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cancelar")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"]))
        : (_openBlock(), _createBlock(Button, {
            key: 1,
            variant: "ghost",
            size: "icon",
            onClick: _cache[8] || (_cache[8] = () => {
                    webhookVerificationToken.value = __props.partnerProvider?.webhookVerificationToken;
                    tokenInProvider.value = __props.partnerProvider?.tokenInProvider;
                    presentationNameInProvider.value = __props.partnerProvider?.presentationNameInProvider;
                    idInProvider.value = __props.partnerProvider?.idInProvider;
                    toggleEdit();
                })
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CircleX), { class: "text-slate-400" })
            ]),
            _: 1
          })),
      (!isEditing.value)
        ? (_openBlock(), _createBlock(Button, {
            key: 2,
            variant: "default",
            size: "icon",
            onClick: toggleEdit,
            class: "px-1.5"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Pencil), { class: "text-white" })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(Button, {
            key: 3,
            variant: "default",
            size: "icon",
            class: "px-1.5",
            onClick: patchPartnerProvider
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CircleCheck), { class: "text-white" })
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})